import React from "react";
import { Button } from "@material-ui/core";
import successGif from "../../../../assets/done-animation.gif";
import { useNavigate } from "react-router-dom";

interface SuccessTotalPaymentWithWalletProps {
  onClose: () => void;
  withCreateAppointment: boolean;
  appointmentCreated: any;
  props: any;
  profileDetails: any;
}

const SuccessTotalPaymentWithWallet: React.FC<
  SuccessTotalPaymentWithWalletProps
> = ({
  onClose,
  withCreateAppointment,
  appointmentCreated,
  props,
  profileDetails,
}) => {
  const navigate = useNavigate();
  return (
    <div className="pld-screen" style={{ textAlign: "center" }}>
      {/* SUCCESS GIF */}
      <div style={{ marginTop: "25px" }}>
        <img src={successGif} alt="success" height="150px" />
      </div>

      {/* TITLE */}
      <div style={{ fontWeight: "bold", fontSize: "22px", marginTop: "10px" }}>
        {withCreateAppointment
          ? "Appointment created successfully!"
          : "Payment successful!"}
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          className="show-shared-options-box zy-dashed-border"
          style={{
            fontWeight: "500",
            fontSize: "18px",
          }}
        >
          {"Appointment ID: " + appointmentCreated?.id}
        </div>
      </div>

      {/* BUTTON */}
      <div className="pld-center" style={{ marginTop: "25px" }}>
        <Button
          className="zy-btn-orange pld-main-btn"
          onClick={
            withCreateAppointment
              ? () => {
                  navigate(`/view?id=${profileDetails?.id}`, { replace: true });
                }
              : onClose
          }
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default SuccessTotalPaymentWithWallet;
